import React, { useState, useEffect } from 'react';
/** components **/
import { Link } from 'react-router-dom';
import { Layout } from 'components/organisms';
import { NewsSkeleton } from 'components/molecules';
import { useLocation } from 'react-router-dom';
import { client } from 'api/microcms';
import dayjs from "dayjs"
import { NewsDetail } from 'types/myTypes';
import PwanImage from 'assets/images/pwan.png';
import PinaImage from 'assets/images/friend02.png';
import PiImage from 'assets/images/friend03.png';
import PappuriImage from 'assets/images/friend04.png';
import TentouImage from 'assets/images/tentou.png';
import AntImage from 'assets/images/ant.png';
import BeeImage from 'assets/images/bee.png';
import MaimaiImage from 'assets/images/maimai.png';
import HotalImage from 'assets/images/hotal.png';
import MonshiroImage from 'assets/images/monshiro.png';
/** styles **/
import s from '../styles/pages/news.module.scss';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const processContent = (content: string) => {
  // キャラクターの絵文字変換
  let processedContent = content;
  
  // FriendItemListのキャラクター
  processedContent = processedContent.replace(/:p-wan/g, `<img src=${PwanImage} alt="p-wan" style="max-width: 50px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  processedContent = processedContent.replace(/:pina/g, `<img src=${PinaImage} alt="pina" style="max-width: 50px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  processedContent = processedContent.replace(/:pi/g, `<img src=${PiImage} alt="pi" style="max-width: 50px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  processedContent = processedContent.replace(/:pappuri/g, `<img src=${PappuriImage} alt="pappuri" style="max-width: 50px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  
  // InsectItemListのキャラクター
  processedContent = processedContent.replace(/:tentou/g, `<img src=${TentouImage} alt="tentou" style="max-width: 30px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  processedContent = processedContent.replace(/:ant/g, `<img src=${AntImage} alt="ant" style="max-width: 30px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  processedContent = processedContent.replace(/:bee/g, `<img src=${BeeImage} alt="bee" style="max-width: 30px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  processedContent = processedContent.replace(/:maimai/g, `<img src=${MaimaiImage} alt="maimai" style="max-width: 30px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  processedContent = processedContent.replace(/:hotal/g, `<img src=${HotalImage} alt="hotal" style="max-width: 30px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  processedContent = processedContent.replace(/:monshiro/g, `<img src=${MonshiroImage} alt="monshiro" style="max-width: 30px; height: auto; display: inline-block;margin-bottom: 0;vertical-align: bottom;" />`);
  
  return processedContent;
}

export const News: React.FC = () => {
  const [news, setNews] = useState<NewsDetail>();
  const [isLoading, setIsLoading] = useState(true);
  const query = useQuery();
  const id = query.get('id');

  const fetch = async () => {
    setIsLoading(true);
    await client
      .get({
        endpoint: "news",
        contentId: id as string,
      })
      .then((res) => {
        setNews(res)
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (id) {
      fetch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);


  return (
    <Layout>
      <div className={s.newsWrapper}>
        <div className={s.contents}>
          {isLoading ? (
            <NewsSkeleton />
          ) : (
            <>
              <p className={s.title}>{news?.title}</p>
              <p className={s.date}>{dayjs(news?.publishedAt).format("YYYY/MM/DD")} <span>{news?.tag}</span></p>
              <div
                className={s.newsBody}
                dangerouslySetInnerHTML={{
                  __html: news?.contents ? processContent(news.contents) : '',
                }}
              />
              <Link className={s.topLink} to="/">
                トップページへ戻る
              </Link>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};
